import React, { useState, useEffect } from 'react';
import { Button, Modal, Table, Badge, Spinner } from "react-bootstrap";
import { LanguageProvider } from '../../../core/language-provider';
import FieldPreviewSimple from '../../Entity/FieldPreviewSimple';
import ModalDetailsActionsHook from '../../../components/Hooks/ModalDetailsActions';
import { settings } from '../../../config/settings';


export default function ModalDetails({ entity, props, data = null, closeModalDetails, entityAllPreferences = null }) {

    const excluded = ['deleted'];
    const [statusModalDetails, setStatusModalDetails] = useState(false);
    const [selectedPreference, setSelectedPreference] = useState(null);
    const [visibleColumns, setVisibleColumns] = useState(null);

    useEffect(() => {
        if (data === null)
            setStatusModalDetails(false)
        else
            setStatusModalDetails(true)
    }, [data]);

    // Gestione preferenze
    const handlePreferenceClick = (preference) => {
        if (preference === 'all') {
            setSelectedPreference('all');
            setVisibleColumns(null); // null significa mostra tutto
        } else {
            setSelectedPreference(preference.id);
            try {
                const content = typeof preference.content === 'string'
                    ? JSON.parse(preference.content)
                    : preference.content;
                setVisibleColumns(content?.columns || []);
            } catch (e) {
                console.error('Errore nel parsing della preferenza:', e);
                setVisibleColumns(null);
            }
        }
    };

    // Controlla se una colonna deve essere visualizzata
    const shouldShowColumn = (columnName) => {
        if (visibleColumns === null) return true; // Mostra tutto
        return visibleColumns.includes(columnName);
    };



    if (props !== null) {
        return (
            <>
                <Modal show={statusModalDetails} onHide={closeModalDetails} size={settings.modalDefaultSize && settings.modalDefaultSize.details ? settings.modalDefaultSize.details : "xl"} scrollable={true} id={'modal-details-' + entity} backdrop="static" >
                    <Modal.Header closeButton>
                        <Modal.Title>{LanguageProvider.get('defaults.details')} - {LanguageProvider.get('entity.' + entity)}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {data !== null ? (
                            <>
                                {entityAllPreferences !== null && (
                                    <div className="d-flex gap-2 mb-3">
                                        <Badge
                                            bg={selectedPreference === 'all' || selectedPreference === null ? 'primary' : 'secondary'}
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => handlePreferenceClick('all')}
                                        >
                                            Visualizza tutto
                                        </Badge>
                                        {entityAllPreferences.map((pref) => (
                                            <Badge
                                                key={pref.id}
                                                bg={selectedPreference === pref.id ? 'primary' : 'secondary'}
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => handlePreferenceClick(pref)}
                                            >
                                                {pref.label || '(senza nome)'}
                                            </Badge>
                                        ))}
                                    </div>
                                )}
                                <Table striped bordered responsive className='small'>
                                    <tbody>
                                        {Object.keys(data).map((key, i) => {
                                            if (!excluded.includes(key) && shouldShowColumn(key)) {
                                                return (
                                                    <tr key={i} data-name={'modal-details-field-' + key}>
                                                        <th>
                                                            <span>{LanguageProvider.getLabel(entity, key)}</span>
                                                        </th>
                                                        <td>
                                                            <FieldPreviewSimple item={data} field={key} props={props} entity={entity} />
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                            return null;
                                        })}
                                    </tbody>
                                </Table>
                            </>
                        ) : (
                            <div className='text-center'>
                                <Spinner size='sm' />
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <ModalDetailsActionsHook entity={entity} data={data} />

                        <Button variant="secondary" onClick={closeModalDetails}>
                            {LanguageProvider.get('defaults.close')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
};